import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

enum paymentOptions {
  Card = 1,
  ACH = 2,
  // GooglePay = 3,
  // ApplePay = 4,
  Venmo = 5,
  PayPal = 6,
  Crypto = 7
}

@Component({
  selector: 'app-payment-options',
  templateUrl: './payment-options.component.html',
  styleUrls: ['./payment-options.component.scss']
})
export class PaymentOptionsComponent implements OnInit {

  constructor() { 

    this.selectedPaymentMethods?.values
  }

  @Input() availablePayments: any[] = [];
  @Input() source: string = '';
  @Input() formSubmit: boolean = false;
  @Output() paymentMethodsChange = new EventEmitter<any[]>();

  @ViewChild('paymentMethodSelect') paymentMethodSelect: NgSelectComponent;
  
  selectedPaymentMethods: any[] = [];

  ngOnInit(): void {
    this.toggleSelectAll();
  }

  isAllSelected(): boolean {
    return (
      this.selectedPaymentMethods.length === this.availablePayments.length
    );
  }
  
  selectAllOptions: boolean = false;
  toggleSelectAll(): void {
    if (!this.selectAllOptions) {
      this.selectedPaymentMethods = this.availablePayments.map(p => p.id);
    } else {
      this.selectedPaymentMethods = [];
    }
    this.selectAllOptions = !this.selectAllOptions;
    this.paymentMethodsChange.emit(this.selectedPaymentMethods);
  }

  selectAll(): void {
    this.selectedPaymentMethods = this.availablePayments.map(p => p.id);
    this.selectAllOptions = true;
    this.paymentMethodsChange.emit(this.selectedPaymentMethods);
  }
  onPaymentChange(selected: any[]): void {
    // const hasApplePay = selected.includes(paymentOptions.ApplePay);
    // const hasGooglePay = selected.includes(paymentOptions.GooglePay);
    // const hasCard = selected.includes(paymentOptions.Card);
  
    // // If Apple Pay or Google Pay is selected, Card must be selected
    // if ((hasApplePay || hasGooglePay) && !hasCard) {
    //   const card = this.availablePayments.find(p => p.id === paymentOptions.Card);
    //   this.selectedPaymentMethods = [...selected, card?.id];
    // }
    if(this.selectedPaymentMethods.length === this.availablePayments.length) {
      this.selectAllOptions = true;
    }
    this.paymentMethodsChange.emit(this.selectedPaymentMethods);
  }

  get paymentPlaceholder(): string | null {
    return this.source === 'mbilling' || this.source === 'invoice'
      ? 'Manage Payment Methods'
      : null;
  }

  focusSelect() {
    this.paymentMethodSelect.focus();
  }

  setSelectedPayments(payments: any[]) {
    this.selectedPaymentMethods = payments;
  }

  onClearAll() {
    this.selectedPaymentMethods = [];
    this.selectAllOptions = false;
    this.paymentMethodsChange.emit(this.selectedPaymentMethods);
  }
}
